import { render, staticRenderFns } from "./ResidentialTownhouseComplex.vue?vue&type=template&id=46d5b40e&scoped=true&"
import script from "./ResidentialTownhouseComplex.vue?vue&type=script&lang=ts&"
export * from "./ResidentialTownhouseComplex.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialTownhouseComplex.vue?vue&type=style&index=0&id=46d5b40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5b40e",
  null
  
)

export default component.exports